<template>
  <div class="page">
    <div class="seiten-kopf">
      <router-link to="/einkaufsliste/kategorien" class="seiten-kopf-zurueck" aria-label="Zurück">
        <font-awesome-icon icon="fa-solid fa-arrow-left" />
      </router-link>
      <h1>Neue Kategorie</h1>
    </div>

    <form class="zutat-form" @submit.prevent>
      <label for="neue-kategorie-name">Name</label>
      <div class="input-field">
        <input id="neue-kategorie-name" v-model="Name" type="text" placeholder="Kategoriename" />
      </div>

      <p v-if="Fehlermeldung" class="error-message">{{ Fehlermeldung }}</p>

      <div class="button-row">
        <button type="button" class="btn btn-primary" @click="Speichern">Speichern</button>
        <router-link to="/einkaufsliste/kategorien" class="btn btn-secondary">Abbrechen</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { KategorieHinzufuegen } from '../composables/useZutaten'

export default {
  name: 'KategorieHinzufuegenView',
  data() {
    return {
      Name: '',
      Fehlermeldung: ''
    }
  },
  methods: {
    async Speichern() {
      this.Fehlermeldung = ''
      if (!this.Name.trim()) {
        this.Fehlermeldung = 'Name darf nicht leer sein.'
        return
      }
      try {
        await KategorieHinzufuegen(this.Name.trim())
        this.$router.push('/einkaufsliste/kategorien')
      } catch (Fehler) {
        this.Fehlermeldung = Fehler.message
      }
    }
  }
}
</script>

<style scoped>
.zutat-form {
  display: flex;
  flex-direction: column;
  max-width: 320px;
  margin-top: 16px;
}

.zutat-form label {
  margin-top: 12px;
  margin-bottom: 4px;
  font-size: 0.9rem;
}
</style>
